import React from "react";

interface FormActionsProps {
    isGenerating: boolean;
    hasItems: boolean;
    onReset: () => void;
}

export const FormActions: React.FC<FormActionsProps> = ({
    isGenerating,
    hasItems,
    onReset
}) => {
    return (
        <div className="flex flex-col sm:flex-row sm:justify-end space-y-2 sm:space-y-0 sm:space-x-3">
            <button
                type="button"
                onClick={onReset}
                className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-200 dark:hover:bg-gray-600 w-full sm:w-auto"
            >
                Reset Form
            </button>
            <button
                type="submit"
                disabled={isGenerating || !hasItems}
                className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 w-full sm:w-auto"
            >
                {isGenerating ? "Generating PDF..." : "Generate Canada Customs Invoice"}
            </button>
        </div>
    );
};
